export default {
  'platform.chinese': 'Simplified Chinese',
  'platform.linkJump': 'External Redirect',
  'platform.internalJump': 'Inner-site Redirect',
  'platform.noJump': 'No redirect',
  'platform.uploadTip': 'Allowed only jpg/png/jpeg/webp, <=1M',
  'platform.uploadError': 'Allowed only jpg/png/jpeg/webp, <=1M',
  'platform.bannerName': 'Carousel Image Name',
  'platform.bannerImage': 'Carousel Image',
  'platform.upload': 'Upload',
  'platform.uploadImage': 'Please upload image',
  'platform.redirectLink': 'Redirect URL',
  'platform.link': 'URL',
  'platform.linkJumpTip': 'Please select the link',
  'platform.announcementName': 'Announcement Name',
  'platform.announcementType': 'Announcement Type',
  'platform.homepagePopup': 'Homepage Popup',
  'platform.homepageMarquee': 'Homepage Marquee',
  'platform.language': 'Language',
  'platform.triggerFrequency': 'Trigger Frequency',
  'platform.triggerFrequency.onceEachTime': 'Each Time',
  'platform.triggerFrequency.oncePerDay': 'Once Per Day',
  'platform.triggerFrequency.oncePerWeek': 'Once Per Week',
  'platform.triggerFrequency.onceOnly': 'Once Only',
  'platform.frontendDisplayStatus': 'Frontend displays status',
  'platform.status': 'Status',
  'platform.remark': 'Remark',
  'platform.operator': 'Operator',
  'platform.operationTime': 'Operate Time',
  'platform.banner': 'Carousel Image',
  'platform.redirectLinkTitle': 'Redirect URL',
  'platform.lobbyId': 'Lobby ID',
  'platform.input': 'Please enter',
  'platform.invitationPage': 'Invitation Page',
  'platform.myAccount': 'My Account',
  'platform.copywriting': 'Copywriting',

  'webPushNotifications.enable': 'Enable',
  'webPushNotifications.add': 'Add',
  'webPushNotifications.save': 'Save',
  'webPushNotifications.disable': 'Disable',
  'webPushNotifications.createTime': 'Create Time',
  'webPushNotifications.targetType': 'Target Type',
  'webPushNotifications.targetTypeAll': 'All Members',
  'webPushNotifications.targetTypeSpecific': 'Specific Members',
  'webPushNotifications.triggerType': 'Trigger Type',
  'webPushNotifications.triggerTypeManual': 'Manual',
  'webPushNotifications.triggerTypeNewUserNextDay': 'New User Next Day',
  'webPushNotifications.triggerTypeWithdrawSuccess': 'Withdraw Success',
  'webPushNotifications.triggerTypeSubRegister': 'Sub Register Success',
  'webPushNotifications.title': 'Push Title',
  'webPushNotifications.content': 'Push Content',
  'webPushNotifications.updateTime': 'Operate Time',
  'webPushNotifications.status': 'Status',
  'webPushNotifications.remark': 'Remark',
  'webPushNotifications.updateBy': 'Operator',
  'webPushNotifications.action': 'Action',
  'webPushNotifications.statusOn': 'Enabled',
  'webPushNotifications.statusOff': 'Disabled',

  'platform.webPushNotifications.targetType': 'Target Type',
  'platform.webPushNotifications.targetTypeAll': 'All Members',
  'platform.webPushNotifications.targetTypeSpecific': 'Specific Members',
  'platform.webPushNotifications.targetMembersPlaceholder':
    'Input member ID; multiple lines or separated by commas',
  'platform.webPushNotifications.targetMembersRequired': 'Please input member ID',
  'platform.webPushNotifications.triggerType': 'Trigger Type',
  'platform.webPushNotifications.triggerTypeManual': 'Manual',
  'platform.webPushNotifications.triggerTypeNewUserNextDay': 'New User Next Day',
  'platform.webPushNotifications.triggerTypeWithdrawSuccess': 'Withdraw Success',
  'platform.webPushNotifications.triggerTypeSubRegister': 'Sub Register Success',
  'platform.webPushNotifications.pushTitle': 'Push Title',
  'platform.webPushNotifications.pushContent': 'Push Content',
  'platform.webPushNotifications.linkUrl': 'Push Link',
  'platform.webPushNotifications.mainButtonTitle': 'Main Button Title',
  'platform.webPushNotifications.mainButtonLink': 'Main Button Link',
  'platform.webPushNotifications.subButtonTitle': 'Sub Button Title',
  'platform.webPushNotifications.subButtonLink': 'Sub Button Link',
  'platform.webPushNotifications.common.input': 'Please input',
  'platform.webPushNotifications.pushImage': 'Push Image',

  'platform.siteMessage.title': 'Title',
  'platform.siteMessage.target': 'Target',
  'platform.siteMessage.createTime': 'Create Time',
  'platform.siteMessage.operator': 'Operator',

  'platform.siteMessage.form.targetType': 'Push Target',
  'platform.siteMessage.form.targetTypeAll': 'All Members',
  'platform.siteMessage.form.targetTypeSpecific': 'Specific Members',
  'platform.siteMessage.form.specifyMembers': 'Specify Members',
  'platform.siteMessage.form.membersPlaceholder':
    'Input member ID; multiple lines or separated by commas',
  'platform.siteMessage.form.membersRequired': 'Please input member ID',
  'platform.siteMessage.form.title': 'Title',
  'platform.siteMessage.form.titlePlaceholder': 'Please input',
  'platform.siteMessage.form.titleRequired': 'Please input title',
  'platform.siteMessage.form.content': 'Content',

  'platform.maxIpRegistrations': 'Max registrations per IP address',
  'platform.maxDeviceRegistrations': 'Max registrations per device',
  'platform.update': 'Update',
  'platform.unlimited': 'Unlimited',
  'platform.updateSuccess': 'Update success',
  'platform.updateFailed': 'Update failed, please try again later',
  'platform.validationError': 'Please input integer between 1 and 999999',
  'platform.registrationSettings': 'Registration Settings',
  'platform.loginSettings': 'Login Settings',
  'platform.phoneSmsLogin': 'Phone + SMS Code',
  'platform.maxDeviceLogins': 'Max Logins per Device',

  'platform.pixelIdTemplate': 'PixelID Template',
  'platform.pixelIdTemplateName': 'PixelID Template Name',
  'platform.point.Channelname': 'Channel Name',
  'platform.point.Channelpromotionlink': 'Channel Promotion Link',
  'platform.point.ChannelID': 'Channel ID',
  'platform.point.Platform': 'Platform',
  'platform.point.PixelID': 'PixelID',
  'platform.point.Notes': 'Notes',
  'platform.point.Operationtime': 'Operation Time',
  'platform.point.Operation': 'Operation',
  'platform.point.AssociatepixelID': 'Associate PixelID',
  'platform.point.Disassociate': 'Disassociate',
  'platform.point.unbindsure':
    'Are you sure to disassociate the channel promotion link and pixelID?',
  'platform.point.Confirm': 'Confirm',
  'platform.point.Cancel': 'Cancel',
  'platform.point.Switch': 'Switch',
  'platform.point.EnableTips': 'Enable: Domain promotion link collects event records normally.',
  'platform.point.DisableTips': 'Disable: Domain promotion link stops collecting event records.',
  'platform.point.Click': 'Click',
  'platform.point.Register': 'Register',
  'platform.point.Recharge': 'Recharge',
  'platform.point.Secondcharge': 'Secondcharge',
  'platform.point.Purchase': 'Purchase',
  'platform.point.Addtocart': 'Add to Cart',
  'platform.point.Initiatecheckout': 'Initiate Checkout',
  'platform.point.Buriedpointrecord': 'Buried Point Record',
  'platform.point.Registrationtime': 'Registration Time',
  'platform.point.starttime': 'Start Time',
  'platform.point.endtime': 'End Time',
  'platform.point.RegistrationURL': 'Registration URL',
  'platform.point.Parentmemberaccount': 'Parent Member Account',
  'platform.point.MemberID': 'Member ID',
  'platform.point.Memberaccount': 'Member Account',
  'platform.point.Event': 'Event',
  'platform.point.Timeofevent': 'Event Time',
  'platform.point.Amount': 'Amount',
  'platform.point.URLofevent': 'Event URL',
  'platform.addPixelId': 'Add PixelID',
  'platform.editPixelId': 'Edit PixelID',
  'platform.viewPixelId': 'View PixelID',
  'platform.trackMode': 'Tracking Type',
  'platform.trackModeCapi': 'Conversions API (S2S)',
  'platform.trackModeWeb': 'Browser (Web Pixel)',
  'platform.inviteLink': 'Domain Link',

  // Promotion channel / domain
  'platform.promoChannel.channelId': 'Channel ID',
  'platform.promoChannel.withdrawRegisterUrl': 'Withdrawal Referral Sign-up URL',

  'platform.promoChannel.ticketRegisterUrl': 'Ticket Referral Sign-up URL',
  'platform.promoChannel.edit': 'Edit Channel',
  'platform.promoChannel.urlPlaceholder': 'Enter URL',
  'platform.promoChannel.urlFormat': 'Enter a valid URL starting with https:// without spaces',
  'platform.promoDomain.domain': 'Promotion Domain',
  'platform.promoDomain.add': 'Add Domains',
  'platform.promoDomain.edit': 'Edit Domain',
  'platform.promoDomain.editTip':
    'Changing the domain or its channel does not change the channel of registered users',
  'platform.promoDomain.batchPlaceholder':
    'Batch add supported, up to {max}. One domain per line, e.g. 123.com',
  'platform.promoDomain.tooMany': 'You can add up to {max} domains at a time',
  'platform.promoDomain.domainLabel': 'Domain',
  'platform.promoDomain.platform': 'Promotion Platform',
  'platform.promoDomain.platformOther': 'Other',
  'platform.promoDomain.tipTitle': 'Tips:',
  'platform.promoDomain.tip1':
    '1. Only add domains you fully control, e.g. domains bought from a registrar.',
  'platform.promoDomain.tip2':
    '2. After adding, point the NS records of the domain to the authoritative name servers provided by the CDN.',
  'platform.promoDomain.tip3':
    '3. Once the records take effect and the main domain shows [Normal], the domain is ready to use.',
  'platform.promoDomain.invalid': 'Invalid domain: {domain}',
  'platform.promoDomain.duplicate': 'Duplicate domain: {domain}',
  'platform.promoDomain.deleteConfirm':
    'Delete this domain? Domains bound to a pixel must be unbound first',

  'platform.suspendedball.cardTitle': 'Floating Ball Configuration',
  'platform.suspendedball.updateBtn': 'Update',
  'platform.suspendedball.updateSuccess': 'Updated successfully',
  'platform.suspendedball.close': 'Off',
  'platform.suspendedball.open': 'On',
  'platform.suspendedball.label': 'Floating Ball',
  'platform.contactConfig.cardTitle': 'Social & Support',
  'platform.contactConfig.typeCustomerService': 'Customer Service',
  'platform.contactConfig.typeEmail': 'Email',
  'platform.contactConfig.save': 'Save Config',
  'platform.contactConfig.sortRange': 'Please enter a sort value between 1 and 99',
  'platform.suspendedball.status': 'Status',
  'platform.suspendedball.uploadBtnText': 'Upload',
  'platform.suspendedball.uploadTip': 'Only jpg/png/webp/gif files can be uploaded',
  'platform.suspendedball.suggestSize': 'Suggested size is',
  'platform.suspendedball.uploadError': 'Incorrect image size or format',
  'platform.suspendedball.uploadRule': 'Please upload a floating ball image',
  'platform.suspendedball.jumpType': 'Redirect Type',
  'platform.suspendedball.externalJump': 'External Link',
  'platform.suspendedball.activityJump': 'Campaign Redirect',
  'platform.suspendedball.jumpLink': 'Redirect Link',
  'platform.suspendedball.placeholderInput': 'Please enter',
  'platform.suspendedball.placeholderSelect': 'Please select',
  'platform.suspendedball.inputRule': 'Please enter the redirect link',
  'platform.suspendedball.selectRule': 'Please select a campaign',

  'platform.operLog': 'Operation Log',
  'platform.operContent': 'Operation Content',
  'platform.operIp': 'Operation IP',

  'report.buriedPointRecord.export': 'Export',
  'report.buriedPointRecord.parentAccountID': 'Parent Account ID',
  'report.buriedPointRecord.accountID': 'Account ID',
  'report.buriedPointRecord.promotionLink': 'Promotion Link',
  'report.buriedPointRecord.eventId': 'Event ID',
  'report.buriedPointRecord.pushStatus': 'Forward Status',
  'report.buriedPointRecord.pushPending': 'Pending',
  'report.buriedPointRecord.pushSuccess': 'Success',
  'report.buriedPointRecord.pushFail': 'Failed',
  'report.buriedPointRecord.pushSkip': 'Not Forwarded',
  // SMS settings
  'platform.smsConfig.smsPlatform': 'SMS Platform',
  'platform.smsConfig.supportCountry': 'Supported Country/Region',
  'platform.smsConfig.contact': 'Contact',
  'platform.smsConfig.fee': 'SMS Fee',
  'platform.smsConfig.feePlaceholder': 'SMS fee, up to 50 characters',
  'platform.smsConfig.currentBalance': 'Current Balance',
  'platform.smsConfig.alertEnabled': 'Balance Alert',
  'platform.smsConfig.alertThreshold': 'Alert When Balance Below',
  'platform.smsConfig.alertThresholdPrefix': 'When balance is below',
  'platform.smsConfig.makeRemind': 'send alert',
  'platform.smsConfig.channelStatus': 'Channel Status',
  'platform.smsConfig.statusUnchecked': 'Unchecked',
  'platform.smsConfig.statusNormal': 'Normal',
  'platform.smsConfig.statusLow': 'Low Balance',
  'platform.smsConfig.statusFailed': 'Check Failed',
  'platform.smsConfig.dailyLimit': 'Daily Cap',
  'platform.smsConfig.noLimit': 'No Cap',
  'platform.smsConfig.todayRemain': 'Remaining Today',
  'platform.smsConfig.todaySent': 'Sent Today',
  'platform.smsConfig.todaySuccess': 'Succeeded Today',
  'platform.smsConfig.todayFail': 'Failed Today',
  'platform.smsConfig.selectCountry': 'Country',
  'platform.smsConfig.platform': 'Platform',
  'platform.smsConfig.enable': 'Enable',
  'platform.smsConfig.disable': 'Disable',
  'platform.smsConfig.alertLow': 'SMS balance is low, please top up in time',
  'platform.smsConfig.alertFailed': 'SMS balance check failed, please check the channel config',
};
